/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState, useRef } from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { useHistory, Link, NavLink } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Socket.io]
-------------------------------------------------------------------*/
import io from "socket.io-client";
/*------------------------------------------------------------------
[End Socket.io]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_POST, API_URL, API_SERVER, API_SCT } from '../../../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {encode, decode} from 'html-entities'
import CurrencyFormat from 'react-currency-format';
import Tour from 'reactour'
import LinesEllipsis from 'react-lines-ellipsis'
import TextTransition, { presets } from "react-text-transition";
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character, console_dev, YEAR } from '../../../../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Etc]
-------------------------------------------------------------------*/
import Logo from '../../../../../assets/img/logo.png'
import OverlayBg from '../../../../../assets/img/overlay_bg_form.png'

import Regulasi from '../../../../../assets/img/simpr_bprb/regulasi.png'
import Persyaratan from '../../../../../assets/img/simpr_bprb/persyaratan.png'
import Pengaduan from '../../../../../assets/img/simpr_bprb/pengaduan.png'
import Pelayanan from '../../../../../assets/img/simpr_bprb/pelayanan.png'
import Data from '../../../../../assets/img/simpr_bprb/data.png'

import Beranda from '../../../../../assets/img/simpr/home/1.png'
import TataRuang from '../../../../../assets/img/simpr/home/2.png'
import Panduan from '../../../../../assets/img/simpr/home/3.png'

/*------------------------------------------------------------------
[End Etc]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Veriable]
-------------------------------------------------------------------*/
let SOCKET_SERVER = process.env.REACT_APP_PRODUCTION === 'false' ? process.env.REACT_APP_SOCKET_SERVER_DEVELOPMENT : process.env.REACT_APP_SOCKET_SERVER_PRODUCTION;
let socket = io(SOCKET_SERVER);
/*------------------------------------------------------------------
[End Variable]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {

    /*--------------------------------------------------------------
    [History]
    ----------------------------------------------------------------*/
    const history = useHistory();
    /*--------------------------------------------------------------
    [End History]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Meta]
    ----------------------------------------------------------------*/
    let meta_title = 'App';
    /*--------------------------------------------------------------
    [End Meta]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Request Params]
    ----------------------------------------------------------------*/
    let request_params = 'app';
    /*--------------------------------------------------------------
    [End Request Params]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Pagination Offset]
    ----------------------------------------------------------------*/
    let pagination_offset = 20;
    /*--------------------------------------------------------------
    [End Pagination Offset]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [tour, set_tour] = useState(false);

    const [refresh, set_refresh] = useState(null);
    const [file, set_file] = useState(null);
    const [bamboo_user, set_bamboo_user] = useState(null);
    const [bamboo_update, set_bamboo_update] = useState('');
    const [bamboo_delete, set_bamboo_delete] = useState('');

    const [table_height, set_table_height] = useState(0);

    const [element, set_element] = useState(null);
    const [sub_element, set_sub_element] = useState(null);
    
    const [pagination_active, set_pagination_active] = useState(1);
    const [path_client, set_path_client] = useState('')
    const [data, set_data] = useState(null);
    const [search, set_search] = useState('');
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [New State]
    ----------------------------------------------------------------*/
    const [test, set_test] = useState('')
    /*--------------------------------------------------------------
    [End New State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Ref]
    ----------------------------------------------------------------*/
    const ref_table_height = useRef(null)
    /*--------------------------------------------------------------
    [End Ref]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/
    const steps = [
        {
          selector: '.___step_1',
          content: 'Content 1',
        },
    ];
    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _read = (pages, bambooUserParams) => {

		let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (pagination_offset * pages) - pagination_offset : 0
        
        }

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`sims/master/get__________?action=read_${request_params}`
            + '&bamboo_user=' + bambooUserParams
            + '&limit=' + pagination_offset
            + '&offset=' + offsetSync
        , 
		).then((response) => {
            console_dev('response read', response.data)
            if(response.data.result == 'success'){
                set_data(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _search = () => {

        if(loading === true){
            return
        }
        
        if(search.length > 3){
    
            API_GET_REQUEST(`sims/master/get__________?action=search_${request_params}`
                + '&bamboo_user=' + bamboo_user
                + '&search=' + search
            , 
            ).then((response) => {
                console_dev('response search', response.data)
                if(response.data.result == 'success'){
                    set_data(response.data.data)
                    error('')
                }else if(response.data.error){
                    error(response.data.error);
                    set_data(null)
                }
            })
            .catch((e) => {
                console_dev('catch', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }

    }

    const _uploads = (action) => {

        if(loading === true){
            return
        }

        loading(true);

        var data = new FormData();
        data.append("sct", API_SCT);
        data.append("key", STORAGE_USER[0].id_key);
        data.append("bamboo_user", bamboo_user);
        data.append("bamboo_update", bamboo_update);
        data.append("bamboo_delete", bamboo_delete);
        data.append("path_client", path_client);
        data.append("action", action);
        // new request --------------------------------
        data.append("test", test);

        if(file !== null){
            file.map((item) => (
                data.append("file", item)
            ))
        }

        var config = {
            method: 'post',
            url: API_URL + "sims/master/post__________",
            headers: { 
                'Authorization': `Bearer ${STORAGE_TOKEN}`,
            },
            data : data,
            onUploadProgress: progressEvent => {
                console.log('loaded : ', progressEvent.loaded)
                console.log('total : ', progressEvent.total)
                if(file !== null){
                    progress(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)))
                }
            }
        };

        axios(config)
        .then((response) => {
            console_dev('response uploads', response.data)
            if(response.data.result === 'success'){
                _read(pagination_active, bamboo_user)
                set_file(null)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                set_path_client('')
                // update state ------------------
                set_test('')
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console_dev('catch', e)
            error(e.message)
        })
        .finally(() => {
			loading(false);
		})

    }

    const _uploads_post = (params) => {

        if(loading === true){
            return 
        }

		loading(true);

		API_POST('sims/master/post__________', {
            bamboo_user: bamboo_user,
            bamboo_update: bamboo_update,
            bamboo_delete: bamboo_delete,
            action: params,
            // new request ------------------------
            test: test,
		}).then((response) => {
            console_dev('response upload post', response.data)
            if(response.data.result == 'success'){
                _read(pagination_active, bamboo_user)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                // update state ------------------
                set_test('')
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Socket]
    ----------------------------------------------------------------*/
    const _socket = (storageUserParams) => {

        // // get
		// socket.on("get", (data) => {
		// 	console.log('get : ', data)	
		// })
		
		// // push
		// socket.emit("push", {
		// 	push : data,
		// });
		
	}
    /*--------------------------------------------------------------
    [End Socket]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
            
            if(event.target.files[0].size > 2048000){
                return error('Ukuran File maxsimal 2MB')
            }else{
                error('')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};
    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Storage User]
    ----------------------------------------------------------------*/
    const _STORAGE_USER = () => {

        if(STORAGE_USER !== undefined){

            let storage_bamboo = STORAGE_USER[0].level === 'admin' ? STORAGE_USER[0].bamboo : STORAGE_USER[0].bamboo_chain;
            
            if(storage_bamboo){
                set_bamboo_user(storage_bamboo)
                _socket(STORAGE_USER[0])
                _read(1, storage_bamboo)
            }

        }else{

            // error('User Not Found')
        
        }

    }
    /*--------------------------------------------------------------
    [End Storage User]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Authentication]
    ----------------------------------------------------------------*/
    // if(STORAGE_USER !== undefined){
    //     if(STORAGE_USER[0].level === 'guest'){
    //         history.push('/')
    //     }
    // }else{
    //     history.push('/home')
    //     window.location.reload();
    // }
    /*--------------------------------------------------------------
    [End Authentication]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Text Animation]
    ----------------------------------------------------------------*/
    const [index, setIndex] = React.useState(0);

    React.useEffect(() => {
        const intervalId = setInterval(() =>
        setIndex(index => index + 1),
        3000 // every 3 seconds
        );
        return () => clearTimeout(intervalId);
    }, []);

    const TEXTS = [
        "Login",
        "Official"
    ];
    /*--------------------------------------------------------------
    [End Text Animation]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        if(search.length > 0){
            _search()
        }else{
            _STORAGE_USER()
        }

    }, [refresh, search])

    useEffect(() => {

        if(ref_table_height.current){
            set_table_height(ref_table_height.current.clientHeight + 5)
        }

    }, [data])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    return (
        <>

            {/*  Helmet ------------------------------------------------------------------ */}
            <Helmet>

                <meta name="description" content={`${meta_title}`}/>
                <title>{`${meta_title}`}</title>

            </Helmet>
            {/*  End Helmet -------------------------------------------------------------- */}

            <div className="_simpr_home_container _bgi_none">

                <div className="fmc-bg-container" style={{backgroundColor: 'transparent'}}>
                    <div className="fmc-layout">
                        <div className="fmc-circle"></div>
                        <div className="fmc-circle"></div>
                        <div className="fmc-circle"></div>
                        <div className="fmc-circle"></div>
                        <div className="fmc-circle"></div>
                        <div className="fmc-circle"></div>
                        <div className="fmc-circle"></div>
                        <div className="fmc-circle"></div>
                        <div className="fmc-circle"></div>
                        <div className="fmc-circle"></div>
                    </div>
                </div>

                <div className="_simpr_home_navbar">
                    <div className="_simpr_home_navbar_logo"></div>
                    <div className="_simpr_home_navbar_middle"></div>
                    <NavLink 
                        to='/simpr/bprb/login'
                        className="_simpr_home_navbar_menu"
                    >
                        <ion-icon name="finger-print-outline"></ion-icon>
                    </NavLink>
                </div>

                <div className="_simpr_home_content_container">
                    <div className="_simpr_home_content_header">
                        {/* <div className="_simpr_home_content_header_width">
                            <h1 style={{fontFamily: 'Roboto-Medium'}} className="_push_t_d">e-Aplikasi</h1>
                        </div> */}
                    </div>
                    <div className="_simpr_home_content">
                        <div className="_simpr_home_content_item">
                            <NavLink 
                                to='/simpr/bprb/data'
                                className="_simpr_home_content_item_box"
                                style={{width: 160, height: 160}}
                            >
                                <img src={Data} style={{maxWidth: 100}} />
                            </NavLink>
                            <div className="_simpr_home_content_item_title">
                                Data
                            </div>
                        </div>
                        <div className="_simpr_home_content_item">
                            <NavLink 
                                to='/simpr/bprb/regulasi'
                                className="_simpr_home_content_item_box"
                                style={{width: 160, height: 160}}
                            >
                                <img src={Regulasi} style={{maxWidth: 80}} />
                            </NavLink>
                            <div className="_simpr_home_content_item_title">
                                Regulasi
                            </div>
                        </div>
                        <div className="_simpr_home_content_item">
                            <NavLink 
                                to='/simpr/bprb/persyaratan'
                                className="_simpr_home_content_item_box"
                                style={{width: 160, height: 160}}
                            >
                                <img src={Persyaratan} style={{maxWidth: 80}} />
                            </NavLink>
                            <div className="_simpr_home_content_item_title">
                                Persyaratan
                            </div>
                        </div>
                        <div className="_simpr_home_content_item">
                            <a 
                                href={"https://lapor.go.id"}
                                className="_simpr_home_content_item_box"
                                style={{width: 160, height: 160}}
                                target="_blank"
                            >
                                <img src={Pengaduan} style={{maxWidth: 80}} />
                            </a>
                            <div className="_simpr_home_content_item_title">
                                Pengaduan
                            </div>
                        </div>
                    </div>
                    <div className="_simpr_home_content">
                        <div className="_simpr_home_content_item">
                            <a 
                                href={"https://www.serdangbedagaikab.go.id"}
                                className="_simpr_home_content_item_box"
                                style={{width: 160, height: 160}}
                                target="_blank"
                            >
                                <img src={Pelayanan} style={{maxWidth: 80}} />
                            </a>
                            <div className="_simpr_home_content_item_title">
                                Pelayanan
                            </div>
                        </div>
                        <div className="_simpr_home_content_item">
                            <NavLink 
                                to='/simpr/bprb/tata_ruang'
                                className="_simpr_home_content_item_box"
                                style={{width: 160, height: 160}}
                            >
                                <img src={TataRuang} style={{maxWidth: 80}} />
                            </NavLink>
                            <div className="_simpr_home_content_item_title">
                                Tata Ruang
                            </div>
                        </div>
                        <div className="_simpr_home_content_item">
                            <NavLink 
                                to='/simpr/bprb/panduan'
                                className="_simpr_home_content_item_box"
                                style={{width: 160, height: 160}}
                            >
                                <img src={Panduan} style={{maxWidth: 80}} />
                            </NavLink>
                            <div className="_simpr_home_content_item_title">
                                Panduan
                            </div>
                        </div>
                        <div className="_simpr_home_content_item">
                            <NavLink 
                                to='/simpr/bprb/home'
                                className="_simpr_home_content_item_box"
                                style={{width: 160, height: 160}}
                            >
                                <img src={Beranda} style={{maxWidth: 80}} />
                            </NavLink>
                            <div className="_simpr_home_content_item_title">
                                Beranda
                            </div>
                        </div>
                    </div>
                </div>

                <div className="_simpr_home_footer">
                    Copyright (c) {YEAR} Dinas Pekerjaan Umum dan Penataan Ruang. Icons by <a href="https://www.freepik.com">Freepik</a>.
                </div>

            </div>

        </>
    );

}

export default Screen;